import { render } from "./Factory.vue?vue&type=template&id=5510ef8c"
import script from "./Factory.vue?vue&type=script&lang=js"
export * from "./Factory.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__